// extracted by mini-css-extract-plugin
export default {"tile":"ViewReservationStatusPage_tile__IP4vW","rest":"ViewReservationStatusPage_rest__+qydt","number":"ViewReservationStatusPage_number__8r5je"};